/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Header } from 'datastake-daf/dist/components';
import { renderBreadCrumbs } from '../../../../helpers/breadCrumbs';
import { DownloadOutlined } from '@ant-design/icons';

export default function AnalysisHeader({
  namespace,
  id = '',
  isOwnData = false,
  sourceId = null,
  mod = '',
  subjectName,
  mode = 'app',
  selectedSourceId,
  datastakeId = ''
}) {
  const { t } = useTranslation();
  const goTo = useNavigate();

  const extraButtons = useMemo(() => {
    let viewLink;

    switch (namespace) {
      case 'kyc':
        viewLink = {
          pathname: `/${mode}/${mod}/view/kyc/user`,
        };
        break;
      case 'scl':
        if (isOwnData) {
          viewLink = {
            pathname: `/${mode}/${mod}/view/scl/${id}`,
          };
        }
        if (sourceId) {
          viewLink = {
            pathname: `/${mode}/${mod}/view/scl/${id}?sourceId=${sourceId}`,
          };
        }
        break;
      case 'amp':
        return [
          {
            label: t('Summary'),
            onClick: () => { },
            className: 'primary',
            key: "view",
          },
          {
            label: t('Application Form'),
            onClick: () => {
              if (sourceId) {
                goTo(`/app/tif/view/amp/${id}?sourceId=${sourceId}`)
              } else {
                goTo(`/app/tif/view/amp/${id}`)
              }
            },
            key: "edit",
          },
          {
            label: t('Mine Profile'),
            onClick: () => {
              if (sourceId) {
                goTo(`/app/tif/view/mine-profile/${id}?sourceId=${sourceId}`)
              } else {
                goTo(`/app/tif/view/mine-profile/${id}`)
              }
            }
          },
          {
            label: t('Ownership & KYC'),
            onClick: () => {
              if (sourceId) {
                goTo(`/app/tif/view/ownership-kyc/${id}?sourceId=${sourceId}`)
              } else {
                goTo(`/app/tif/view/ownership-kyc/${id}`)
              }
            },
          },
          {
            label: t('ESG Assessment'),
            disabled: true,
            onClick: () => {
              if (sourceId) {
                goTo(`/app/tif/view/esg-assessment/${id}?sourceId=${sourceId}`)
              } else {
                goTo(`/app/tif/view/esg-assessment/${id}`)
              }
            }
          },
          {
            label: t('Production Reports'),
            disabled: true,
          },
        ];
      case 'scp':
        if (isOwnData) {
          viewLink = {
            pathname: `/${mode}/${mod}/view/scp/${id}`,
          };
        }
        if (sourceId) {
          viewLink = {
            pathname: `/${mode}/${mod}/view/scp/${id}?sourceId=${sourceId}`,
          };
        }
        break;
      case 'mine-operators':
        if (isOwnData) {
          viewLink = {
            pathname: `/${mode}/${mod}/view/mine-operators/${id}`,
          };
        }
        if (sourceId) {
          viewLink = {
            pathname: `/${mode}/${mod}/view/mine-operators/${id}?sourceId=${sourceId}`,
          };
        }
        break;
      default:
    }

    return [];
  }, [t, namespace, id, isOwnData, sourceId]);

  const breadCrumbs = useMemo(() => {
    return renderBreadCrumbs({
      t,
      goTo,
      mod,
      isAnalysis: true,
      view: namespace,
      id,
      sourceId: selectedSourceId,
      subjectName,
    });
  }, [goTo, t, id, selectedSourceId, subjectName])

  const tags = useMemo(() => {
    if (datastakeId) {
      if (namespace === 'amp') {
        return [{ label: datastakeId.replace('STK', 'AMP') }];
      }
      return [{ label: datastakeId }];
    }

    return [];
  }, [datastakeId]);

  const actionButtons = useMemo(() => {
    const options = [];
    let viewLink;

    switch (namespace) {
      case 'kyc':
        viewLink = {
          pathname: `/${mode}/${mod}/view/kyc/user`,
        };
        break;
      case 'scl':
        if (isOwnData) {
          viewLink = {
            pathname: `/${mode}/${mod}/view/scl/${id}`,
          };
        }
        if (sourceId) {
          viewLink = {
            pathname: `/${mode}/${mod}/view/scl/${id}?sourceId=${sourceId}`,
          };
        }
        break;
      case 'scp':
        if (isOwnData) {
          viewLink = {
            pathname: `/${mode}/${mod}/view/scp/${id}`,
          };
        }
        if (sourceId) {
          viewLink = {
            pathname: `/${mode}/${mod}/view/scp/${id}?sourceId=${sourceId}`,
          };
        }
        break;
      case 'mine-operators':
        if (isOwnData) {
          viewLink = {
            pathname: `/${mode}/${mod}/view/mine-operators/${id}`,
          };
        }
        if (sourceId) {
          viewLink = {
            pathname: `/${mode}/${mod}/view/mine-operators/${id}?sourceId=${sourceId}`,
          };
        }
        break;
      case 'programs':
        viewLink = { pathname: `/app/tif/view/programs/${id}` };
        break;
      default:
    }

    if (viewLink) {
      options.push({
        type: 'primary',
        label: t('Details'),
        onClick: () => goTo(viewLink.pathname),
      })
    }

    return options;
  }, [namespace, t]);

  const supportText = useMemo(() => {
    switch (namespace) {
      case 'amp':
        return t('Consolidated monitoring of AMP operations and performance.');
      default:
    }
  }, [namespace, t]);

  return (
    <Header
      tags={tags}
      breadcrumbs={breadCrumbs}
      title={subjectName}
      actionButtons={actionButtons}
      supportText={supportText}
      extraButtons={extraButtons}
      onDownload={() => { }}
    />
  );
}
